import getFreshSideObject from './getFreshSideObject.js';

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

export { mergePaddingObject as default };
